import React, { useEffect, FC } from "react";
import CloseIcon from "../../assets/img/Close-Icon.svg";

const Modal: FC<{ modalToggleHandler: any }> = (props) => {
  useEffect(() => {
    const closeOnEscapeKey = (e: any) =>
      e.key === "Escape" ? props.modalToggleHandler() : null;
    document.body.addEventListener("keydown", closeOnEscapeKey);
    return () => {
      document.body.removeEventListener("keydown", closeOnEscapeKey);
    };
  }, [props.modalToggleHandler]);

  return (
    <div className="modal">
      <div className="modal__blur">
        <div className="modal__box">
          <div className="modal__controls">
            <img
              src={CloseIcon}
              alt="Close icon"
              className="modal__controls__icon"
              onClick={props.modalToggleHandler}
            />
          </div>
          <div className="modal__text">
            <h2 className="heading heading--secondary">
              This application is powered by DecisionRules.
            </h2>
            <p className="text text--primary">
              DecisionRules helps you speed up everyday decision making
              processes in e-commerce, logistics, health, financial industry,
              and more.
            </p>
          </div>
          <div className="modal__cta">
            <a
              href="https://app.decisionrules.io/auth/register?type=true-registration"
              className="cta cta--primary"
            >
              Try DecisionRules
            </a>
            <a
              href="https://www.decisionrules.io/en/get-a-demo"
              className="cta cta--secondary"
            >
              Book a demo
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
